import React from "react";
import { Item } from "../../../interfaces/interfaces";
import classNames from "classnames";
import defaultStyle from "../row.module.scss";
import RowItem from "./components/RowItem/RowItem";

type RowProps = {
  items: Item[];
};

const Row = ({ items }: RowProps) => {
  return (
    <div className={classNames(defaultStyle.row)}>
      {items.map((item: Item, index: number) => {
        return <RowItem data={item} key={index} isTrending={true} />;
      })}
    </div>
  );
};

export default Row;
